import axios from "axios";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL
});

export const fetchGifts = async (params={}) => {
  const res = await API.get("/gifts", { params });
  return res.data;
};

export const fetchGiftBySlug = async (slug) => {
  const res = await API.get(`/gifts/${slug}`);
  return res.data;
};

export const fetchGiftAddons = async (giftId) => {
  const res = await API.get(`/gifts/${giftId}/addons`);
  return res.data;
};

export const addGiftToCart = async (payload) => {
  const token = localStorage.getItem("token");
  const res = await API.post("/cart/add-gift", payload, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return res.data;
};
